define(['t3', 'hy/hy-module', 'hy/hy-utils', 'lodash', 'events', 'jquery', 'lib/jquery-ui/autocomplete', 'lib/jquery-ui/widget'], function (T3, BaseModule, hyutils, lodash, EVENTS, $, autocomplete) {

    'use strict';

    return BaseModule.addModule('common/modules/opl-autocomplete', function (context) {

        var options = {
            url: '',
            urlParams: [], // {key: value}, {key, value}
            type: 'POST',
            dataType: 'json',
            data: '',
            maxResults: 10,
            responsdatavalue: 'value',
            responsdatalabel: 'label',
            responsdatadesc: 'description',
            responsaditionaldata: 'aditionaldata',
            responsImages: 'images',
            responsUrl: 'url',
            responsgroupLabel: 'category',
            loadAllClass: 'loadAllClass',
            loadAllLabel: '+ pokaż wszystkie',
            removeFromListText: 'usuń',
            sortElements: true,
            displayUnCategorizedFirst: false,
            elementWraper: false,
            completecallback: '',
            minLength: 3,
            showMinLengthMessage: false,
            minLengthMessageText: 'Wprowadź minimum 3 znaki',
            minLengthMessageContainerClass: 'opl-autocomplete__message',
            autofocus: true,
            arrayData: false,
            noWrap: false,
            responsTextArray: false,
            responseTextJSON: false,
            theme: null,
            autosubmit: false,
            autosubmitAddParams: [],
            autosubmitFormaId: '',

            addHintsToCache: false

        };
        var moduleEl, $moduleEl, elementWraper, dataElements = [], userLStorage = null,
            maxResults, allElements, showAllResults = false,
            ul, messageState = false,
            separatorsCount = 0;

        // Array Object sort
        function sortBy() {
            var _args = Array.prototype.slice.call(arguments);
            return function (a, b) {
                return _args
                    .map(function (o) {
                        var dir = 1;
                        if (o[0] === '-') {
                            dir = -1;
                            o = o.substring(1);
                        }
                        if (a[o] > b[o]) {
                            return dir;
                        }
                        if (a[o] < b[o]) {
                            return -(dir);
                        }
                        return 0;
                    })
                    .reduce(function (p, n) {
                        return Boolean(p) ? p : n;
                    }, 0);
            };
        }


        var customRenderMenu = function (ul, items) {
            var self = this;

            /**
             * set hint items selected before, and stored in local.storage
             */
            if (options.addHintsToCache && userLStorage) {
                var storList = userLStorage.toSearch($moduleEl.val());
                for (var item in storList) {
                    if (storList.hasOwnProperty(item)) {
                        items.unshift(_.assign({}, storList[item], {fromStorage: storList[item].value}));
                    }
                }
            }
            renderListMenu(ul, items, self);
        };

        function renderListMenu(ul, items, self) {
            var sortedElements = {
                suggestions: [],
                unCategorized: [],
                categorized: []
            };
            var li;

            function addToCategorized(el) {

                var hasCategory = $.map(sortedElements.categorized, function (elem) {
                    return elem.catName === el.groupLabel ? elem : null;
                });

                if (hasCategory.length === 0) {
                    sortedElements.categorized.push({
                        catName: el.groupLabel,
                        list: [el]
                    });
                } else {
                    hasCategory[0].list.push(el);
                }

            }

            /**
             * dispatch elements to categorized || unCategorized arrays;
             */
            $.each(items, function (i, item) {
                if (item.hasOwnProperty('fromStorage')) {
                    sortedElements.suggestions.push(item);
                }
                else if (item.hasOwnProperty('groupLabel') && item.groupLabel !== undefined && item.groupLabel !== "") {
                    addToCategorized(item);
                } else {
                    sortedElements.unCategorized.push(item);
                }
            });

            /**
             * renderList
             * @param self
             * @param li
             * @param items
             */
            function renderList(self, li, items) {

                $.each(items, function (index, item) {

                    li = self._renderItemData(ul, item);

                    li.append((item.description !== undefined) ? '<span>' + item.description + '</span>' : '');
                    li.append((item.aditionaldata !== undefined) ? '<div class="aditionaldata">' + item.aditionaldata + '</div>' : '');

                    //create button withe options - remove from local.storage
                    if (item.hasOwnProperty('fromStorage')) {
                        li.addClass('item-from-cache');
                        li.append('<a href="#" data-value="' + item.value + '" class="remove-button ui-state-disabled disabled">' + options.removeFromListText + '</a>');
                    }

                    if (item.images !== undefined) {
                        li.addClass('ui-menu-item--image');
                        var $img = $('<span class="ui-menu-item--image-wrapper"><img src="' + item.images + '" alt=""></span>');
                        li.prepend($img);
                    }

                    if (item.url !== undefined && item.images !== undefined) {
                        li.addClass('ui-menu-item--image-url');
                        li.wrapInner('<a href="' + item.url + '"></a>');
                    }

                });

                ul.append('<li class="group-separator group-separator_' + (separatorsCount++) + ' ui-state-disabled disabled" aria-label="false"></li>');

            }

            /**
             * render show all option when response has more elements than configuration described by options.maxResults
             */
            function rendershowAllResults() {
                if (allElements > maxResults) {
                    li = self._renderItemData(ul, {
                        value: 'loadAll',
                        label: options.loadAllLabel,
                        loadAllClass: options.loadAllClass
                    });
                }
                showAllResults = false;
            }


            /**
             * sort element in response
             */
            if (options.sortElements) {
                sortedElements.suggestions.sort(sortBy('label'));
                sortedElements.unCategorized.sort(sortBy('label'));
                sortedElements.categorized.sort(sortBy('catName'));

                $.each(sortedElements.categorized, function (i, elem) {
                    elem.list.sort(sortBy('label'));
                });

            }

            /**
             * displayUnCategorizedFirst
             */
            if (options.displayUnCategorizedFirst === true) {
                renderList(self, li, sortedElements.suggestions);
                renderList(self, li, sortedElements.unCategorized);
                $.each(sortedElements.categorized, function (i, group) {
                    ul.append('<li class="group-label ui-state-disabled disabled" aria-label="false">' + group.catName + '</li>');
                    renderList(self, li, group.list);
                });
                rendershowAllResults();
            } else {
                renderList(self, li, sortedElements.suggestions);
                $.each(sortedElements.categorized, function (i, group) {
                    ul.append('<li class="group-label ui-state-disabled disabled" aria-label="false">' + group.catName + '</li>');
                    renderList(self, li, group.list);
                });
                renderList(self, li, sortedElements.unCategorized);
                rendershowAllResults();
            }

        }


        var customResizeMenu = function () {
            ul = this.menu.element;
            ulMenuSizes();
            $(window).on('resize', _.debounce(ulMenuSizes, 150));
        };

        function ulMenuSizes() {
            var triggerWidth = ul.parent().find("input").outerWidth(),
                width, left, max, result;

            //reset
            ul.outerWidth("auto");
            ul.children().css({
                "white-space": "nowrap"
            });

            //find values
            width = ul.outerWidth();
            left = ul.offset().left;
            max = $(window).width();
            result = max - (left * 2);


            //calculate width
            if (width <= triggerWidth + 30) {
                ul.outerWidth(triggerWidth);
                ul.children().css({
                    "white-space": "pre-line"
                });
            } else {
                if (width + left > max) {
                    ul.outerWidth(result);
                    ul.children().css({
                        "white-space": "pre-line"
                    });
                } else {
                    ul.outerWidth("auto");
                }
            }
        }

        function isURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?' + // port
                '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
                '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return pattern.test(str);
        }

        function insertParam(url, key, value) {

            url = isURL(url) ? new URL(url) : new URL(url, window.location.origin);
            key = encodeURI(key);
            value = encodeURI(value);

            var updatedUrl = url;

            if (url.href.toString().includes(key + '=')) return false;

            var kvp = url.search.substr(1).split('?');
            if (kvp[0] === '') {
                updatedUrl += '?' + key + '=' + value;
                return updatedUrl;
            } else {
                updatedUrl += '&' + key + '=' + value;
                return updatedUrl;
            }
        }


        function requestUrl() {

            var requestedURL = options.url;
            if (options.urlParams.length > 0) {
                _.forEach(options.urlParams, function (param) {
                    requestedURL = insertParam(requestedURL, Object.entries(param)[0][0], Object.entries(param)[0][1]);
                });
                return requestedURL;
            } else {
                return requestedURL;
            }
        }


        function submitData() {
            autocomplete({
                    source: function (request, response) {

                        separatorsCount = 0;

                        if (!options.arrayData) {
                            $.ajax({
                                url: requestUrl(),
                                type: options.type,
                                dataType: options.dataType,
                                data: (function () {

                                    if (options.dataType === 'json') {
                                        return JSON.stringify({
                                            filter: options.data,
                                            html: request.term
                                        });
                                    } else if (options.dataType === 'text') {
                                        var requies = {};
                                        var key = $(moduleEl).attr('name');
                                        requies[key] = $(moduleEl).val();
                                        return requies;
                                    }

                                })(),
                                success: function (data) {

                                    if (options.responsTextArray) {
                                        var arrayData = JSON.parse(data);
                                        var newarray = [];
                                        $.each(arrayData, function (index, value) {
                                            newarray.push({
                                                name: index,
                                                value: value
                                            });
                                        });
                                        data = newarray;
                                    }

                                    if (options.responseTextJSON) {
                                        data = JSON.parse(data);
                                    }

                                    allElements = data.length;
                                    maxResults = showAllResults ? maxResults : options.maxResults;

                                    var elements = $.map(data.slice(0, maxResults), function (item) {
                                        return {
                                            value: item[options.responsdatavalue],
                                            label: item[options.responsdatalabel],
                                            description: item[options.responsdatadesc],
                                            aditionaldata: item[options.responsaditionaldata],
                                            groupLabel: item[options.responsgroupLabel],
                                            images: item[options.responsImages],
                                            url: item[options.responsUrl]
                                        };
                                    });
                                    response(elements);
                                }
                            });
                        } else {

                            allElements = dataElements.length;
                            maxResults = showAllResults ? maxResults : options.maxResults;

                            var list = $.map(dataElements.slice(0, maxResults), function (item) {
                                return {
                                    value: item[options.responsdatavalue],
                                    label: item[options.responsdatalabel],
                                    description: item[options.responsdatadesc],
                                    aditionaldata: item[options.responsaditionaldata],
                                    groupLabel: item[options.responsgroupLabel],
                                    images: item[options.responsImages],
                                    url: item[options.responsUrl]
                                };
                            });

                            response(autocomplete.filter(list, request.term));

                        }
                    },
                    _change: function () {
                        renderMessage();
                    },
                    open: function () {
                        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                            $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
                        }
                    },
                    minLength: options.minLength,
                    appendTo: elementWraper,
                    autoFocus: options.autofocus,
                    create: function () {
                        $(this).data('ui-autocomplete')._renderMenu = customRenderMenu;
                        $(this).data('ui-autocomplete')._resizeMenu = customResizeMenu;
                    },

                    select: function (event, ui) {

                        if (options.addHintsToCache && userLStorage) {
                            userLStorage.setLS(ui.item);
                        }

                        if (ui.item.url !== undefined) {
                            event.preventDefault();
                            document.location.href = ui.item.url;
                            return false;
                        }
                        if (ui.item === undefined) {
                            event.preventDefault();
                            $(this).keydown();
                            return false;
                        }
                        if (ui.item.value === 'loadAll') {
                            showAllResults = true;
                            maxResults = allElements;
                            $(this).keydown();
                            return false;
                        } else if (event.keyCode === 9 && options.autofocus) {
                            maxResults = options.maxResults;
                            event.preventDefault();
                            $moduleEl.val(ui.item.label);
                            completeCallback(ui);
                        } else {
                            $moduleEl.val(ui.item.label);
                            completeCallback(ui);
                        }

                        if (options.autosubmit && options.autosubmitAddParams.length > 0) {
                            var formActionURL = $(options.autosubmitFormaId);
                            _.forEach(options.autosubmitAddParams, function (param) {
                                formActionURL.append('<input type="hidden" name="' + Object.entries(param)[0][0] + '" value="' + Object.entries(param)[0][1] + '"/>');
                            });
                            $(options.autosubmitFormaId).submit();
                        }

                        if (options.autosubmit && options.autosubmitAddParams.length === 0) {
                            $(options.autosubmitFormaId).submit();
                        }

                        return false;
                    },
                    focus: function (event) {
                        event.preventDefault();
                    }
                },
                $moduleEl
            );
        }

        function completeCallback(data) {
            context.broadcast(EVENTS.modules.autocomplete.itemSelected, data, moduleEl.id);

            if (options.completecallback) {
                if (typeof options.completecallback === 'function') {
                    options.completecallback(data);
                } else {
                    eval(options.completecallback);
                }
            }
        }

        function renderMessage() {

            $moduleEl.after('<div class="' + options.minLengthMessageContainerClass + '"></div>');

            $moduleEl.on('keyup', lodash.debounce(function (e) {
                if ((e.currentTarget.value.length < options.minLength && e.currentTarget.value.length > 0 && e.keyCode !== 13) && !messageState) {
                    $moduleEl.next('.' + options.minLengthMessageContainerClass).html('<div class="opl-msg opl-msg--error opl-msg--context"><p>' + options.minLengthMessageText + '</p></div>');
                } else if (e.keyCode === 13) {
                    return false;
                } else {
                    $moduleEl.next('.' + options.minLengthMessageContainerClass).html('');
                }
            }, 300));

        }


        /**
         * logic to store last selected item from autocomplete to local.storage
         */
        function LsManager(name) {
            this.localStorage = window.localStorage;
            this.name = name.replace(/[^\w\s]/gi, '');
            this.hintList = [];

            this.init();
        }

        LsManager.prototype.init = function () {
            var ls = this.localStorage[this.name];
            if (typeof ls === 'string') {
                ls = JSON.parse(ls);
            }
            for (var obj in ls) {
                if (ls.hasOwnProperty(obj)) {
                    this.hintList.push(ls[obj]);
                }
            }
        };

        LsManager.prototype.setLS = function (hint) {
            this.hint = hint;
            for (var i in this.hintList) {
                if (this.hintList.hasOwnProperty(i) && (this.hintList[i].value === this.hint.value)) {
                    return false;
                }
            }
            this.hintList.push(this.hint);
            window.localStorage.removeItem(this.name);
            window.localStorage.setItem(this.name, JSON.stringify(this.hintList));
            return this.localStorage[this.name];
        };

        LsManager.prototype.toSearch = function (toFind) {
            this.toFind = toFind;
            var results = [];
            for (var i in this.hintList) {
                if (this.hintList.hasOwnProperty(i) && (this.hintList[i].label.toLowerCase().indexOf(this.toFind.toLowerCase()) !== -1)) {
                    results.push(this.hintList[i]);
                }
            }
            return results;
        };

        LsManager.prototype.getList = function () {
            return this.hintList;
        };

        LsManager.prototype.toRemove = function (elem) {
            if (elem.attr('data-value') === undefined || elem.attr('data-value') === '') return false;

            _.remove(this.hintList, function (obj) {
                return obj.value === elem.attr('data-value');
            });
            window.localStorage.removeItem(this.name);
            window.localStorage.setItem(this.name, JSON.stringify(this.hintList));
            elem.parent().remove();
        };

        // LsManager.prototype.removeHistory = function () {
        //     window.localStorage.removeItem(this.name);
        // };

        function addHintsToCache() {

            userLStorage = new LsManager(moduleEl.id);

            $(document).on('click', $moduleEl.find('.remove-button'), function (e) {
                userLStorage.toRemove($(e.target));
            });

        }


        return {
            init: function () {
                options = lodash.merge({}, options, context.element.options);
                moduleEl = context.getElement();
                $moduleEl = $(moduleEl);

                !options.noWrap ? $moduleEl.wrap('<div class="opl-autocomplete"></div>') : null;
                options.theme === 'shadow' && !options.noWrap ? $moduleEl.parent().addClass('opl-autocomplete--shadow') : null;
                maxResults = options.maxResults;
                elementWraper = !options.elementWraper ? $moduleEl.parent() : $(options.elementWraper);

                submitData();

                if (options.addHintsToCache) {
                    addHintsToCache();
                }

                // render message with options.messageText text
                if (options.showMinLengthMessage) {
                    renderMessage();
                }

            },

            destroy: function () {
                $moduleEl.autocomplete("destroy");
            },

            messages: [EVENTS.modules.autocomplete.querydata, EVENTS.modules.autocomplete.arrayData, EVENTS.modules.autocomplete.itemSelected],

            onmessage: function (name, data) {
                switch (name) {
                    case EVENTS.modules.autocomplete.querydata:
                        options.data = data;
                        break;
                    case EVENTS.modules.autocomplete.arrayData:
                        dataElements = data;
                        break;
                    default:
                        break;
                }
            }
        };
    });
});
